export default "__VITE_ASSET__NEwMnUOE__"